import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se 'allowedRoles' for definido e o 'role' do usuário não estiver na lista, redireciona.
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redireciona para o dashboard (ou uma página de "Acesso Negado")
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;